var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "app"
  }, [_c('AppHeader'), _c('div', {
    staticClass: "app-body"
  }, [_c('Sidebar', {
    attrs: {
      "navItems": _vm.nav
    }
  }), _c('main', {
    staticClass: "main bg-gray-50"
  }, [_vm.announcement.length ? _c('VueSlickCarousel', {
    staticClass: "mb-0 custom-dots px-4 mx-0 mt-4",
    attrs: {
      "arrows": false,
      "dots": true,
      "autoplay": false,
      "autoplaySpeed": 4000,
      "infinite": true,
      "slidesToShow": 1,
      "slidesToScroll": 1
    }
  }, _vm._l(_vm.announcement, function (item) {
    return _c('div', {
      key: item.id
    }, [_c('div', {
      staticClass: "bg-blue-50 text-blue-800 w-full h-custom px-3 py-3 rounded-md"
    }, [_c('div', {
      staticClass: "flex justify-start w-full"
    }, [_c('div', {
      staticClass: "mr-2"
    }, [_c('svg', {
      staticClass: "w-6 h-6 text-blue-800 dark:text-white",
      attrs: {
        "aria-hidden": "true",
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "fill": "currentColor",
        "viewBox": "0 0 24 24"
      }
    }, [_c('path', {
      attrs: {
        "fill-rule": "evenodd",
        "d": "M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm9.408-5.5a1 1 0 1 0 0 2h.01a1 1 0 1 0 0-2h-.01ZM10 10a1 1 0 1 0 0 2h1v3h-1a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2h-1v-4a1 1 0 0 0-1-1h-2Z",
        "clip-rule": "evenodd"
      }
    })])]), _c('div', {
      staticClass: "content-announcement"
    }, [_c('p', {
      staticClass: "font-semibold mb-1"
    }, [_vm._v(" " + _vm._s(item.title) + " ")]), _c('p', {
      staticStyle: {}
    }, [_vm._v(" " + _vm._s(item.message) + " ")])])])])]);
  }), 0) : _vm._e(), _c('div', {
    staticClass: "container-fluid"
  }, [_c('router-view')], 1)], 1)], 1), _c('AppFooter')], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }